import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navigation = ({ recordingState = 'idle' }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 处理录音按钮点击
  const handleRecordClick = () => {
    console.log('🎤 导航栏录音按钮被点击', {
      currentPath: location.pathname,
      recordingState
    });

    // 如果正在录音，不执行任何操作
    if (recordingState === 'recording' || recordingState === 'paused') {
      console.log('⏭️ 正在录音中，跳过操作');
      return;
    }

    // 如果已经在录音页面，检查是否有URL参数
    if (location.pathname === '/' || location.pathname.startsWith('/recording') || location.pathname.startsWith('/record-test')) {
      // 如果有URL参数（说明是在查看历史录音），则返回到录音准备页面
      if (location.pathname !== '/' && location.pathname !== '/recording') {
        console.log('🔙 在历史录音页面，返回到录音准备页面');
        navigate('/recording', { replace: true });
        return;
      }
      // 如果已经在录音准备页面，不做任何操作
      console.log('⏭️ 已在录音准备页面，跳过操作');
      return;
    }

    // 否则跳转到录音页面
    console.log('🚀 跳转到录音页面');
    navigate('/recording');
  };

  // 判断当前页面是否为录音页面
  const isRecordPage = location.pathname === '/' || location.pathname.startsWith('/recording') || location.pathname.startsWith('/record-test');
  const isListPage = location.pathname === '/records';
  const isSettingsPage = location.pathname === '/settings';

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-black border-t border-gray-800">
      <div className="flex justify-around py-3">
        <button
          onClick={handleRecordClick}
          className={`flex flex-col items-center space-y-1 transition-colors ${
            isRecordPage
              ? 'text-white'
              : (recordingState === 'recording' || recordingState === 'paused')
                ? 'text-red-500' // 正在录音时显示红色
                : 'text-gray-400 hover:text-white'
          }`}
          title={
            isRecordPage
              ? '当前在录音页面'
              : (recordingState === 'recording' || recordingState === 'paused')
                ? '正在录音中，无法切换页面'
                : '开始录音'
          }
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10" />
            <circle cx="12" cy="12" r="3" />
          </svg>
          <span className="text-xs">
            {recordingState === 'recording' ? '录音中' :
             recordingState === 'paused' ? '已暂停' : '录音'}
          </span>
        </button>

        <button
          onClick={() => navigate('/records')}
          className={`flex flex-col items-center space-y-1 transition-colors ${
            isListPage ? 'text-white' : 'text-gray-400 hover:text-white'
          }`}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M4 6h16M4 12h16M4 18h16" />
          </svg>
          <span className="text-xs">列表</span>
        </button>

        <button
          onClick={() => navigate('/settings')}
          className={`flex flex-col items-center space-y-1 transition-colors ${
            isSettingsPage ? 'text-white' : 'text-gray-400 hover:text-white'
          }`}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="3" />
            <path d="M12 1v6m0 6v6m6.36-13.36l-4.24 4.24M7.88 16.12l-4.24 4.24M1 12h6m6 0h6m-13.36 6.36l4.24-4.24m8.48 0l4.24 4.24" />
          </svg>
          <span className="text-xs">设置</span>
        </button>
      </div>
    </div>
  );
};

export default Navigation;